import React from 'react'
import classNames from 'classnames'
import JournalMenu from '../../JournalMenu'
import { ContainedNavItemProps } from '../'
import styles from '../styles.css'
import { useExperiment } from '@deal/experiment-js'
import { NavItem } from '../../../Desktop/TopLevelNavItem'

const JournalNavItem: React.FC<ContainedNavItemProps> = ({
  children,
  onNavItemMouseEnter,
  onNavItemMouseLeave,
  isNavItemHovered
}) => {
  const { result: journalExperimentResult } = useExperiment({
    experiment: 'desktop-journal-navigation',
    defaultTreatment: 'off'
  })

  if (journalExperimentResult === 'v1') {
    return (
      <li
        data-testid="desktop-journal-menu-trigger"
        className={styles.browseNavItem}
        onMouseEnter={() => {
          onNavItemMouseEnter()
        }}
        onMouseLeave={() => {
          onNavItemMouseLeave()
        }}
      >
        <span
          className={classNames(styles.navItemLink, {
            [styles.navItemLinkHovered]: isNavItemHovered
          })}
        >
          <div className={styles.navItemHighlight}>{children}</div>
        </span>

        <div
          className={classNames(styles.menuContent, {
            [styles.visible]: isNavItemHovered
          })}
        >
          <JournalMenu />
        </div>
      </li>
    )
  }

  if (journalExperimentResult === 'v2') {
    return (
      <NavItem to="/journal">
        <span>Expert Journal</span>
      </NavItem>
    )
  }

  return null
}

export default JournalNavItem
